import React, { useState } from "react";
import { Button, Modal, DatePicker, Row, Col, Typography } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import axiosInstance from "utilities/axios";
import dayjs from "dayjs";

const { Text } = Typography;

const PrintButton = ({ search, filters, visible, setVisible }) => {
	const [loading, setLoading] = useState(false);
	const [date, setDate] = useState(() => {
		return dayjs().subtract(1, 'year');
	});

	const handlePrint = () => {
		const params = {
			search: search,
			clinics: filters.clinics,
			category: filters.category,
			brand: filters.brand,
			model: filters.model,
			date: date.format("YYYY-MM-DD"),
		};

		setLoading(true);
		axiosInstance
			.get("/equipment/calibrations/print", { params, responseType: "blob" }) // Ensure server sends a blob
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement("a");
				link.href = url;
				//get file name from response headers
				link.setAttribute(
					"download",
					response.headers["content-disposition"].split("filename=")[1]
				);

				document.body.appendChild(link);
				link.click();
				link.parentNode.removeChild(link); // Clean up
				window.URL.revokeObjectURL(url); // Free up resources
			})
			.catch((error) => {
				console.error("Error printing:", error);
			})
			.finally(() => {
				setLoading(false);
			});
	}

	return (
		<Modal
			title="Print Calibrations"
			open={visible}
			onCancel={() => setVisible(false)}
			footer={[]}
		>
			<div className="mt-4 flex flex-col">
				<Text>Calibrations Since</Text>
				<DatePicker
					value={date}
					onChange={(date) => setDate(date)}
					style={{ marginBottom: 16 }}
				/>
				<Button
					type="primary"
					size="large"
					className="ml-2"
					icon={<PrinterOutlined />}
					onClick={() => handlePrint()}
					loading={loading}
				>
					Print
				</Button>
			</div>
		</Modal>
	);
};

export default PrintButton;